import React, { useState, useRef, useEffect } from 'react';
import '../estilos/Recepcion.css';
import { obtenerActividadesKpi, calcularTerminoEstimado } from '../../servicios/programaService';

const MatrizRecepcion = ({
  certificados = [],
  secciones = [],
  miembrosEquipo = [],
  fechasRecepcion = {},
  mesesRecepcion: mesesRecepcionProp = 0,
  onActualizarFechasRecepcion,
  onCrearCertificado,
  onActualizarCertificado,
  onEliminarCertificado,
  onCompletarCertificado,
  onAgregarDocumento,
  onActualizarDocumento,
  onEliminarDocumento,
  onToggleDocumentoCompletado,
  onCrearSeccion,
  onEliminarSeccion,
}) => {
  const fileInputRefs = useRef({});

  // Solo estado local de UI
  const [mostrarFormAgregar, setMostrarFormAgregar] = useState(false);
  const [nuevaEspecialidad, setNuevaEspecialidad] = useState('');
  const [nuevoNombrePartida, setNuevoNombrePartida] = useState('');
  const [nuevoTerminoPartida, setNuevoTerminoPartida] = useState('');
  const [nuevaSeccion, setNuevaSeccion] = useState('');
  const [mostrarListaSecciones, setMostrarListaSecciones] = useState(false);
  const [seccionesExpandidas, setSeccionesExpandidas] = useState(new Set());
  // Estado para expandir/colapsar partidas y agregar documentos
  const [partidasExpandidas, setPartidasExpandidas] = useState({});
  const [agregarDocPartida, setAgregarDocPartida] = useState(null);
  const [nuevoDocNombre, setNuevoDocNombre] = useState('');

  const [mesesRecepcion, setMesesRecepcion] = useState(mesesRecepcionProp);
  const [modoDesdePrograma, setModoDesdePrograma] = useState(false);
  const [actividadesPrograma, setActividadesPrograma] = useState([]);
  const [cargandoActividades] = useState(false);
  const [terminoEstimado, setTerminoEstimado] = useState(null);

  useEffect(() => { setMesesRecepcion(mesesRecepcionProp); }, [mesesRecepcionProp]);

  const sincronizadoRef = useRef(false);

  useEffect(() => {
    obtenerActividadesKpi().then(acts => {
      const estimado = calcularTerminoEstimado(acts);
      setTerminoEstimado(estimado);

      if (estimado) {
        const estimadoStr = estimado.toLocaleDateString('en-CA', { timeZone: 'America/Santiago' });

        // Sincronizar fechaRecepcionEsperada si difiere del ritmo actual
        if (!sincronizadoRef.current && onActualizarFechasRecepcion &&
            estimadoStr !== fechasRecepcion.fechaRecepcionEsperada) {
          sincronizadoRef.current = true;
          onActualizarFechasRecepcion({
            fechaRecepcionPrograma: fechasRecepcion.fechaRecepcionPrograma || null,
            fechaRecepcionEsperada: estimadoStr,
            mesesRecepcion: fechasRecepcion.mesesRecepcion ?? 0,
          }).catch(() => { sincronizadoRef.current = false; });
        }
      }

      // Pre-cargar actividades para el selector "Desde Programa"
      if (acts.length > 0) {
        const mapaDeduplicado = {};
        for (const a of acts) {
          if (!a.nombre) continue;
          const prev = mapaDeduplicado[a.nombre];
          if (!prev || new Date(a.fechaFinBase) > new Date(prev.fechaFinBase)) {
            mapaDeduplicado[a.nombre] = a;
          }
        }
        const deduplicadas = Object.values(mapaDeduplicado).sort((a, b) =>
          (a.orden ?? 0) - (b.orden ?? 0)
        );
        setActividadesPrograma(deduplicadas);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [busquedaPartida, setBusquedaPartida] = useState('');
  const [mostrarListaPartidas, setMostrarListaPartidas] = useState(false);

  // Edición inline de partida
  const [editandoPartida, setEditandoPartida] = useState(null);
  const [editNombre, setEditNombre] = useState('');
  const [editTermino, setEditTermino] = useState('');
  const [editModoPrograma, setEditModoPrograma] = useState(false);
  const [editBusqueda, setEditBusqueda] = useState('');
  const [editMostrarLista, setEditMostrarLista] = useState(false);


  // Debounce timers para auto-save
  const debounceTimers = useRef({});

  const agregarCertificado = async () => {
    if (!nuevoNombrePartida.trim()) return;
    const espFinal = nuevaEspecialidad === '__nueva__' ? '' : nuevaEspecialidad.trim();
    try {
      await onCrearCertificado({
        especialidad: espFinal,
        nombrePartida: nuevoNombrePartida.trim(),
        terminoPartida: nuevoTerminoPartida || null,
        documentos: []
      });
      setNuevaEspecialidad('');
      setNuevoNombrePartida('');
      setNuevoTerminoPartida('');
      setModoDesdePrograma(false);
      setBusquedaPartida('');
      setMostrarListaPartidas(false);
      setMostrarFormAgregar(false);
    } catch (error) {
      console.error('Error al agregar partida:', error);
    }
  };

  const agregarSeccion = async () => {
    if (!nuevaSeccion.trim()) return;
    const nombre = nuevaSeccion.trim();
    const yaExiste = secciones.some(s => s.name.toLowerCase() === nombre.toLowerCase());
    if (yaExiste) return;
    try {
      await onCrearSeccion({ nombre });
      setNuevaSeccion('');
    } catch (error) {
      console.error('Error al agregar sección:', error);
    }
  };

  const eliminarSeccion = async (seccionId) => {
    try {
      await onEliminarSeccion(seccionId);
    } catch (error) {
      console.error('Error al eliminar sección:', error);
    }
  };

  const iniciarEdicion = (cert) => {
    setEditandoPartida(cert.id);
    setEditNombre(cert.nombrePartida || '');
    setEditTermino(cert.terminoPartida || '');
    setEditModoPrograma(false);
    setEditBusqueda('');
    setEditMostrarLista(false);
  };

  const cancelarEdicion = () => {
    setEditandoPartida(null);
    setEditNombre('');
    setEditTermino('');
    setEditBusqueda('');
    setEditMostrarLista(false);
  };

  const guardarEdicionPartida = async (certId) => {
    if (!editNombre.trim()) return;
    try {
      await onActualizarCertificado(certId, {
        nombrePartida: editNombre.trim(),
        terminoPartida: editTermino || null,
      });
      cancelarEdicion();
    } catch (error) {
      console.error('Error al guardar edición de partida:', error);
    }
  };

  const eliminarPartida = async (id) => {
    try {
      await onEliminarCertificado(id);
    } catch (error) {
      console.error('Error al eliminar partida:', error);
    }
  };

  // Auto-save con debounce para campos de texto de documentos
  const actualizarCampoDocConDebounce = (certId, docId, campo, valor) => {
    const key = `doc-${certId}-${docId}-${campo}`;
    if (debounceTimers.current[key]) clearTimeout(debounceTimers.current[key]);
    debounceTimers.current[key] = setTimeout(() => {
      onActualizarDocumento(certId, docId, { [campo]: valor }).catch(err =>
        console.error('Error al guardar campo documento:', err)
      );
    }, 800);
  };

  const agregarDocumentoAPartida = async (certId) => {
    if (!nuevoDocNombre.trim()) return;
    try {
      await onAgregarDocumento(certId, { nombre: nuevoDocNombre.trim() });
      setNuevoDocNombre('');
      setAgregarDocPartida(null);
      // Auto-expandir la partida
      setPartidasExpandidas(prev => ({ ...prev, [certId]: true }));
    } catch (error) {
      console.error('Error al agregar documento:', error);
    }
  };

  const eliminarDocumento = async (certId, docId) => {
    try {
      await onEliminarDocumento(certId, docId);
    } catch (error) {
      console.error('Error al eliminar documento:', error);
    }
  };

  // Agrupar certificados (partidas) por especialidad
  const getFilasAgrupadas = () => {
    const ordenEspecialidades = [];
    const grupos = {};
    certificados.forEach((cert, idx) => {
      const esp = cert.especialidad?.trim() || 'Sin Sección';
      if (!grupos[esp]) {
        grupos[esp] = [];
        ordenEspecialidades.push(esp);
      }
      grupos[esp].push({ cert, indexOriginal: idx });
    });
    return { ordenEspecialidades, grupos };
  };
  const { ordenEspecialidades, grupos } = getFilasAgrupadas();

  // Contar total de documentos
  const totalDocumentos = certificados.reduce((sum, c) => sum + (c.documentos?.length || 0), 0);


  const agregarArchivos = (certId, docId, files) => {
    const cert = certificados.find(c => c.id === certId);
    if (!cert) return;
    const doc = cert.documentos.find(d => d.id === docId);
    if (!doc) return;
    const nuevosArchivos = Array.from(files).map(file => {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = () => {
          resolve({
            nombre: file.name,
            archivoBase64: reader.result.split(',')[1],
            mimeType: file.type,
            tamano: file.size,
            fechaSubida: new Date()
          });
        };
        reader.readAsDataURL(file);
      });
    });
    Promise.all(nuevosArchivos).then(archivosConvertidos => {
      const archivosActualizados = [...(doc.archivos || []), ...archivosConvertidos];
      onActualizarDocumento(certId, docId, { archivos: archivosActualizados }).catch(err =>
        console.error('Error al subir archivos:', err)
      );
    });
  };

  const eliminarArchivo = (certId, docId, archivoIdx) => {
    const cert = certificados.find(c => c.id === certId);
    if (!cert) return;
    const doc = cert.documentos.find(d => d.id === docId);
    if (!doc) return;
    const archivosActualizados = doc.archivos.filter((_, i) => i !== archivoIdx);
    onActualizarDocumento(certId, docId, { archivos: archivosActualizados }).catch(err =>
      console.error('Error al eliminar archivo:', err)
    );
  };


  const agregarMesesAFecha = (fecha, meses) => {
    if (!fecha || !meses) return fecha;
    const d = new Date(fecha);
    d.setMonth(d.getMonth() + parseInt(meses));
    return d;
  };

  const [mesesGuardando, setMesesGuardando] = useState(false);
  const guardarMesesRecepcion = async () => {
    if (!onActualizarFechasRecepcion) return;
    setMesesGuardando(true);
    try {
      const base = terminoEstimado
        ? terminoEstimado.toLocaleDateString('en-CA', { timeZone: 'America/Santiago' })
        : (fechasRecepcion.fechaRecepcionEsperada || null);
      await onActualizarFechasRecepcion({
        fechaRecepcionPrograma: fechasRecepcion.fechaRecepcionPrograma || null,
        fechaRecepcionEsperada: base,
        mesesRecepcion: mesesRecepcion,
      });
    } catch {
      // error manejado en el handler
    } finally {
      setMesesGuardando(false);
    }
  };

  const togglePartida = (certId) => {
    setPartidasExpandidas(prev => ({ ...prev, [certId]: !prev[certId] }));
  };

  const mesesCortos = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return '—';
    const partes = fechaStr.split('-');
    if (partes.length !== 3) return fechaStr;
    const dia = partes[2];
    const mes = mesesCortos[parseInt(partes[1], 10) - 1] || partes[1];
    const anio = partes[0];
    return `${dia}/${mes}/${anio}`;
  };

  const mesesLargos = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  const formatearFechaLarga = (fechaStr) => {
    if (!fechaStr) return '—';
    const partes = String(fechaStr).split('T')[0].split('-');
    if (partes.length !== 3) return fechaStr;
    const dia = parseInt(partes[2], 10);
    const mes = mesesLargos[parseInt(partes[1], 10) - 1] || partes[1];
    const anio = partes[0];
    return `${dia}/${mes}/${anio}`;
  };

  const getColorFecha = (fechaStr) => {
    if (!fechaStr) return null;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fecha = new Date(fechaStr + 'T12:00:00');
    fecha.setHours(0, 0, 0, 0);
    const diffMs = fecha - hoy;
    const diasRestantes = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    if (diasRestantes <= 0) {
      return { bg: '#1a1a1a', color: '#ffffff', border: '#1a1a1a', label: diasRestantes === 0 ? 'Vence hoy' : `Vencido hace ${Math.abs(diasRestantes)} día${Math.abs(diasRestantes) !== 1 ? 's' : ''}` };
    }
    if (diasRestantes <= 12) {
      return { bg: '#fef2f2', color: '#dc2626', border: '#fca5a5', label: `Crítico · ${diasRestantes} día${diasRestantes !== 1 ? 's' : ''}` };
    }
    if (diasRestantes <= 15) {
      return { bg: '#fff7ed', color: '#ea580c', border: '#fdba74', label: `Alto · ${diasRestantes} días` };
    }
    if (diasRestantes <= 20) {
      return { bg: '#fefce8', color: '#ca8a04', border: '#fcd34d', label: `Medio · ${diasRestantes} días` };
    }
    if (diasRestantes <= 25) {
      return { bg: '#f0fdf4', color: '#16a34a', border: '#86efac', label: `Bajo · ${diasRestantes} días` };
    }
    return null;
  };



  return (
    <div className="tab-content">
      <section className="recepcion-placeholder-section">
        {/* Header */}
        <div className="recepcion-header-bar">
          <span className="recepcion-badge">RECEPCION</span>
          <span className="recepcion-header-title">Matriz de Recepcion</span>
          <span style={{ marginLeft: 'auto', fontSize: '13px', color: '#6b7280' }}>
            {certificados.length} partida{certificados.length !== 1 ? 's' : ''} · {totalDocumentos} documento{totalDocumentos !== 1 ? 's' : ''}
          </span>
        </div>

        <div id="seccion-recepcion" className="recepcion-banner">
          <div className="recepcion-fields">
            <div className="recepcion-field recepcion-field-programada">
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                <span className="recepcion-fecha-casilla">
                  {terminoEstimado ? formatearFechaLarga(terminoEstimado.toLocaleDateString('en-CA', { timeZone: 'America/Santiago' })) : '—'}
                </span>
                <span style={{ fontSize: '13px', color: '#6b7280' }}>+</span>
                <input
                  type="number"
                  min="0"
                  max="120"
                  className="recepcion-input"
                  style={{ width: '70px' }}
                  value={mesesRecepcion}
                  onChange={e => setMesesRecepcion(parseInt(e.target.value) || 0)}
                  onKeyDown={e => { if (e.key === 'Enter') guardarMesesRecepcion(); }}
                  title="Meses a sumar al término del programa"
                />
                <span style={{ fontSize: '13px', color: '#6b7280' }}>meses</span>
                <button
                  className="recepcion-form-submit"
                  style={{ padding: '5px 14px', fontSize: '12px' }}
                  onClick={guardarMesesRecepcion}
                  disabled={mesesGuardando}
                >
                  {mesesGuardando ? 'Guardando…' : 'Guardar'}
                </button>
                {terminoEstimado && (
                  <>
                    <span style={{ fontSize: '13px', color: '#6b7280' }}>→</span>
                    <span className="recepcion-fecha-casilla">
                      {formatearFechaLarga(
                        agregarMesesAFecha(terminoEstimado, mesesRecepcion)
                          .toLocaleDateString('en-CA', { timeZone: 'America/Santiago' })
                      )}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Barra de botones de acción */}
        <div className="recepcion-actions-row">
          <button
            className={`recepcion-action-btn ${mostrarFormAgregar ? 'recepcion-action-active' : 'recepcion-action-green'}`}
            onClick={() => setMostrarFormAgregar(v => !v)}
          >
            {mostrarFormAgregar ? 'Ocultar Formulario' : '+ Agregar Partida'}
          </button>
        </div>

        {/* Panel Agregar Partida */}
        {mostrarFormAgregar && (
          <section className="recepcion-config-section">
            <h2>Partida relacionada a certificación</h2>

            {/* Toggle Manual / Desde Programa */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
              <button
                type="button"
                className={`recepcion-action-btn ${!modoDesdePrograma ? 'recepcion-action-active' : ''}`}
                onClick={() => setModoDesdePrograma(false)}
              >
                Ingresar Manual
              </button>
              <button
                type="button"
                className={`recepcion-action-btn ${modoDesdePrograma ? 'recepcion-action-active' : ''}`}
                onClick={() => setModoDesdePrograma(true)}
              >
                Desde Programa
              </button>
            </div>

            <form className="recepcion-form-grid" onSubmit={(e) => { e.preventDefault(); agregarCertificado(); }}>
              {modoDesdePrograma ? (
                cargandoActividades ? (
                  <span className="recepcion-form-input" style={{ color: '#6b7280' }}>Cargando actividades...</span>
                ) : actividadesPrograma.length === 0 ? (
                  <span className="recepcion-form-input" style={{ color: '#6b7280' }}>No hay programa importado en este proyecto</span>
                ) : (
                  <div style={{ position: 'relative' }}>
                    {/* Botón disparador — muestra la partida seleccionada o placeholder */}
                    <div
                      className="recepcion-form-input"
                      style={{ cursor: 'pointer', userSelect: 'none', color: nuevoNombrePartida ? '#e5e7eb' : '#6b7280' }}
                      onClick={() => { setBusquedaPartida(''); setMostrarListaPartidas(v => !v); }}
                    >
                      {nuevoNombrePartida || '-- Seleccionar partida del programa --'}
                    </div>

                    {/* Dropdown con buscador interno */}
                    {mostrarListaPartidas && (
                      <div style={{
                        position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
                        background: '#ffffff', border: '1px solid #d1d5db', borderRadius: '6px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                      }}>
                        {/* Input de búsqueda dentro del dropdown */}
                        <div style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>
                          <input
                            type="text"
                            className="recepcion-form-input"
                            placeholder="Buscar partida..."
                            value={busquedaPartida}
                            autoComplete="off"
                            autoFocus
                            style={{ margin: 0 }}
                            onChange={(e) => setBusquedaPartida(e.target.value)}
                            onBlur={() => setTimeout(() => setMostrarListaPartidas(false), 150)}
                          />
                        </div>
                        {/* Lista filtrada */}
                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {actividadesPrograma
                            .filter(act => act.nombre.toLowerCase().includes(busquedaPartida.toLowerCase()))
                            .map(act => (
                              <div
                                key={act._id}
                                onMouseDown={() => {
                                  setNuevoNombrePartida(act.nombre);
                                  setNuevoTerminoPartida(act.fechaFinBase ? new Date(act.fechaFinBase).toISOString().split('T')[0] : '');
                                  setBusquedaPartida('');
                                  setMostrarListaPartidas(false);
                                }}
                                style={{
                                  padding: '8px 12px', cursor: 'pointer', fontSize: '13px',
                                  color: '#111827', borderBottom: '1px solid #e5e7eb'
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                              >
                                {act.nombre}
                              </div>
                            ))
                          }
                          {actividadesPrograma.filter(act => act.nombre.toLowerCase().includes(busquedaPartida.toLowerCase())).length === 0 && (
                            <div style={{ padding: '8px 12px', color: '#6b7280', fontSize: '13px' }}>Sin resultados</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )
              ) : (
                <input
                  type="text"
                  className="recepcion-form-input"
                  placeholder="Nombre de partida..."
                  value={nuevoNombrePartida}
                  onChange={(e) => setNuevoNombrePartida(e.target.value)}
                  autoFocus
                />
              )}
              <input
                type="date"
                className="recepcion-form-input"
                value={nuevoTerminoPartida}
                onChange={(e) => { if (!modoDesdePrograma) setNuevoTerminoPartida(e.target.value); }}
                readOnly={modoDesdePrograma}
                title="Término de Partida"
                style={modoDesdePrograma ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
              />
              <select
                className="recepcion-form-input"
                value={nuevaEspecialidad}
                onChange={(e) => setNuevaEspecialidad(e.target.value)}
              >
                <option value="">-- Seleccionar Sección Certificación --</option>
                {[...secciones].sort((a, b) => a.name.localeCompare(b.name)).map((sec) => (
                  <option key={sec.id} value={sec.name}>{sec.name}</option>
                ))}
                <option value="__nueva__">+ Nueva Sección...</option>
              </select>
              {nuevaEspecialidad === '__nueva__' && (
                <input
                  type="text"
                  className="recepcion-form-input"
                  placeholder="Escribir nueva sección certificación..."
                  onChange={(e) => setNuevaEspecialidad(e.target.value)}
                  autoFocus
                />
              )}
              <button
                type="submit"
                className="recepcion-form-submit"
                disabled={!nuevoNombrePartida.trim()}
              >
                Agregar Partida
              </button>
            </form>

            {/* Gestionar Secciones */}
            <div className="recepcion-section-manager">
              <h3>Secciones Recepcion</h3>
              <div className="recepcion-section-inputs">
                <input
                  type="text"
                  className="recepcion-form-input"
                  placeholder="Nombre de la sección..."
                  value={nuevaSeccion}
                  onChange={(e) => setNuevaSeccion(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregarSeccion(); } }}
                />
                <button type="button" className="recepcion-form-submit" onClick={agregarSeccion} disabled={!nuevaSeccion.trim()}>
                  Agregar Sección
                </button>
              </div>
              <button
                type="button"
                className="recepcion-btn-ver-secciones"
                onClick={() => setMostrarListaSecciones(v => !v)}
              >
                {mostrarListaSecciones ? 'Ocultar Secciones' : `Ver Secciones (${secciones.length})`}
              </button>
              {mostrarListaSecciones && secciones.length > 0 && (
                <div className="recepcion-section-list">
                  {secciones.map((sec) => (
                    <div key={sec.id} className="recepcion-section-list-item">
                      <span>{sec.name}</span>
                      <button
                        type="button"
                        className="recepcion-section-delete"
                        onClick={() => eliminarSeccion(sec.id)}
                        title="Eliminar sección"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {mostrarListaSecciones && secciones.length === 0 && (
                <p className="recepcion-config-hint" style={{ marginTop: '8px' }}>No hay secciones creadas aún.</p>
              )}
            </div>
          </section>
        )}

        {/* Tabla */}
        <div className="recepcion-table-wrapper">
          <table className="recepcion-table">
            <thead>
              <tr>
                <th className="recepcion-th-numero" style={{ width: '40px' }}>#</th>
                <th className="recepcion-th-documento">Nombre de Partida</th>
                <th className="recepcion-th-fecha">Término de Partida</th>
                <th style={{ width: '80px', textAlign: 'center' }}>Docs</th>
                <th className="recepcion-th-acciones">Acc.</th>
              </tr>
            </thead>
            <tbody>
              {ordenEspecialidades.map((esp) => {
                const items = grupos[esp];
                const totalDocsEsp = items.reduce((sum, { cert }) => sum + (cert.documentos?.length || 0), 0);
                const colapsada = !seccionesExpandidas.has(esp);
                const toggleSeccion = () => setSeccionesExpandidas(prev => {
                  const next = new Set(prev);
                  next.has(esp) ? next.delete(esp) : next.add(esp);
                  return next;
                });
                return (
                  <React.Fragment key={`seccion-${esp}`}>
                    {/* Fila de sección/especialidad — clickeable */}
                    <tr className="recepcion-section-row" onClick={toggleSeccion} style={{ cursor: 'pointer' }}>
                      <td colSpan={6} className="recepcion-section-header">
                        <div className="recepcion-section-header-inner">
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{colapsada ? '▶' : '▼'}</span>
                            <span className="recepcion-section-name">{esp}</span>
                          </div>
                          <span className="recepcion-section-count">
                            {items.length} partida{items.length !== 1 ? 's' : ''} · {totalDocsEsp} doc{totalDocsEsp !== 1 ? 's' : ''}
                          </span>
                        </div>
                      </td>
                    </tr>
                    {/* Filas de partidas — solo si la sección está expandida */}
                    {!colapsada && items.map(({ cert, indexOriginal }) => {
                      const expandida = partidasExpandidas[cert.id];
                      const editando = editandoPartida === cert.id;
                      return (
                        <React.Fragment key={cert.id}>
                          {/* Fila de la partida — modo edición inline */}
                          {editando ? (
                            <tr className="recepcion-table-row" style={{ background: '#fffbeb' }}>
                              <td className="recepcion-td-numero">{indexOriginal + 1}</td>
                              <td>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                  <div style={{ display: 'flex', gap: '4px' }}>
                                    <button
                                      type="button"
                                      className={`recepcion-action-btn${!editModoPrograma ? ' recepcion-action-active' : ''}`}
                                      style={{ fontSize: '11px', padding: '3px 10px' }}
                                      onClick={() => { setEditModoPrograma(false); setEditBusqueda(''); setEditMostrarLista(false); }}
                                    >Manual</button>
                                    <button
                                      type="button"
                                      className={`recepcion-action-btn${editModoPrograma ? ' recepcion-action-active' : ''}`}
                                      style={{ fontSize: '11px', padding: '3px 10px' }}
                                      onClick={() => setEditModoPrograma(true)}
                                    >Desde Programa</button>
                                  </div>
                                  {editModoPrograma ? (
                                    actividadesPrograma.length === 0 ? (
                                      <span style={{ fontSize: '12px', color: '#6b7280' }}>No hay programa importado</span>
                                    ) : (
                                      <div style={{ position: 'relative' }}>
                                        <div
                                          className="recepcion-form-input"
                                          style={{ cursor: 'pointer', userSelect: 'none', fontSize: '13px', color: editNombre ? '#111827' : '#6b7280' }}
                                          onClick={() => { setEditBusqueda(''); setEditMostrarLista(v => !v); }}
                                        >
                                          {editNombre || '-- Seleccionar partida --'}
                                        </div>
                                        {editMostrarLista && (
                                          <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 200, background: '#fff', border: '1px solid #d1d5db', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                                            <div style={{ padding: '6px', borderBottom: '1px solid #e5e7eb' }}>
                                              <input
                                                type="text"
                                                className="recepcion-form-input"
                                                placeholder="Buscar..."
                                                value={editBusqueda}
                                                autoFocus
                                                style={{ margin: 0, fontSize: '12px' }}
                                                onChange={e => setEditBusqueda(e.target.value)}
                                                onBlur={() => setTimeout(() => setEditMostrarLista(false), 150)}
                                              />
                                            </div>
                                            <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                                              {actividadesPrograma
                                                .filter(act => act.nombre.toLowerCase().includes(editBusqueda.toLowerCase()))
                                                .map(act => (
                                                  <div
                                                    key={act._id}
                                                    onMouseDown={() => {
                                                      setEditNombre(act.nombre);
                                                      setEditTermino(act.fechaFinBase ? act.fechaFinBase.split('T')[0] : '');
                                                      setEditMostrarLista(false);
                                                    }}
                                                    style={{ padding: '7px 12px', cursor: 'pointer', fontSize: '13px', borderBottom: '1px solid #f3f4f6' }}
                                                    onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                                                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                  >
                                                    {act.nombre}
                                                  </div>
                                                ))}
                                              {actividadesPrograma.filter(act => act.nombre.toLowerCase().includes(editBusqueda.toLowerCase())).length === 0 && (
                                                <div style={{ padding: '8px 12px', color: '#6b7280', fontSize: '13px' }}>Sin resultados</div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )
                                  ) : (
                                    <input
                                      type="text"
                                      className="recepcion-input recepcion-input-documento"
                                      value={editNombre}
                                      onChange={e => setEditNombre(e.target.value)}
                                      autoFocus
                                      style={{ margin: 0 }}
                                      onKeyDown={e => { if (e.key === 'Enter') guardarEdicionPartida(cert.id); if (e.key === 'Escape') cancelarEdicion(); }}
                                    />
                                  )}
                                </div>
                              </td>
                              <td>
                                <input
                                  type="date"
                                  className="recepcion-form-input"
                                  value={editTermino}
                                  onChange={e => { if (!editModoPrograma) setEditTermino(e.target.value); }}
                                  readOnly={editModoPrograma}
                                  style={{ fontSize: '12px', padding: '4px 6px', ...(editModoPrograma ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
                                />
                              </td>
                              <td style={{ textAlign: 'center' }}>
                                {(() => {
                                  const docsCompletados = (cert.documentos || []).filter(d => d.completado).length;
                                  const totalDocs = (cert.documentos || []).length;
                                  const todosCompletados = totalDocs > 0 && docsCompletados === totalDocs;
                                  return (
                                    <span style={{ fontSize: '0.8rem', fontWeight: 600, padding: '2px 8px', borderRadius: '10px', background: todosCompletados ? '#dcfce7' : '#f1f5f9', color: todosCompletados ? '#15803d' : '#64748b' }}>
                                      {totalDocs > 0 ? `${docsCompletados}/${totalDocs}` : '0'}
                                    </span>
                                  );
                                })()}
                              </td>
                              <td className="recepcion-td-acciones">
                                <button
                                  className="recepcion-btn-add-doc-ok"
                                  onClick={() => guardarEdicionPartida(cert.id)}
                                  disabled={!editNombre.trim()}
                                  title="Guardar"
                                  style={{ marginRight: '4px' }}
                                >✓</button>
                                <button
                                  className="recepcion-btn-add-doc-cancel"
                                  onClick={cancelarEdicion}
                                  title="Cancelar"
                                >✕</button>
                              </td>
                            </tr>
                          ) : (
                          /* Fila normal — click en la fila despliega documentos */
                          <tr
                            className="recepcion-table-row recepcion-partida-row"
                            onClick={() => togglePartida(cert.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            <td className="recepcion-td-numero">{indexOriginal + 1}</td>
                            <td>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{expandida ? '▼' : '▶'}</span>
                                <span className="recepcion-input recepcion-input-documento" style={{ display: 'block', cursor: 'pointer' }}>
                                  {cert.nombrePartida}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="recepcion-fecha-texto">
                                {formatearFecha(cert.terminoPartida)}
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              {(() => {
                                const docsCompletados = (cert.documentos || []).filter(d => d.completado).length;
                                const totalDocs = (cert.documentos || []).length;
                                const todosCompletados = totalDocs > 0 && docsCompletados === totalDocs;
                                return (
                                  <span style={{
                                    fontSize: '0.8rem', fontWeight: 600, padding: '2px 8px',
                                    borderRadius: '10px',
                                    background: todosCompletados ? '#dcfce7' : '#f1f5f9',
                                    color: todosCompletados ? '#15803d' : '#64748b'
                                  }}>
                                    {totalDocs > 0 ? `${docsCompletados}/${totalDocs}` : '0'}
                                  </span>
                                );
                              })()}
                            </td>
                            <td className="recepcion-td-acciones" onClick={e => e.stopPropagation()}>
                              <button
                                className="recepcion-btn-editar"
                                onClick={() => iniciarEdicion(cert)}
                                title="Editar partida"
                                style={{ marginRight: '4px' }}
                              >✏</button>
                              <button
                                className="recepcion-btn-eliminar"
                                onClick={() => eliminarPartida(cert.id)}
                                title="Eliminar partida"
                              >
                                ✕
                              </button>
                            </td>
                          </tr>
                          )}

                          {/* Sub-tabla de documentos (expandible) */}
                          {expandida && (
                            <tr className="recepcion-docs-expandable-row">
                              <td colSpan={6} style={{ padding: 0 }}>
                                <div className="recepcion-docs-container">
                                  <table className="recepcion-docs-table">
                                    <thead>
                                      <tr>
                                        <th style={{ width: '30px' }}>#</th>
                                        <th style={{ width: '36px', textAlign: 'center' }}>✓</th>
                                        <th className="recepcion-th-documento">Documento Recepción Final</th>
                                        <th className="recepcion-th-fecha">Fecha Programa</th>
                                        <th className="recepcion-th-archivos">Archivos</th>
                                        <th className="recepcion-th-observaciones">Observaciones</th>
                                        <th style={{ width: '40px' }}>Acc.</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(cert.documentos || []).map((doc, docIdx) => {
                                        const alertaEsperada = getColorFecha(doc.fechaEsperada);
                                        const fileInputKey = `${cert.id}-${doc.id}`;
                                        return (
                                          <tr key={doc.id} className={`recepcion-doc-row${doc.completado ? ' recepcion-doc-completado' : ''}`}>
                                            <td style={{ textAlign: 'center', color: '#6b7280', fontSize: '12px' }}>{docIdx + 1}</td>
                                            <td style={{ textAlign: 'center' }}>
                                              <input
                                                type="checkbox"
                                                checked={doc.completado || false}
                                                onChange={() => onToggleDocumentoCompletado(cert.id, doc.id)}
                                                title={doc.completado ? 'Desmarcar completado' : 'Marcar como completado'}
                                                style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#111827' }}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="text"
                                                className="recepcion-input recepcion-input-documento"
                                                placeholder="Nombre del documento..."
                                                defaultValue={doc.nombre}
                                                onBlur={(e) => {
                                                  if (e.target.value !== doc.nombre) {
                                                    onActualizarDocumento(cert.id, doc.id, { nombre: e.target.value });
                                                  }
                                                }}
                                                onChange={(e) => actualizarCampoDocConDebounce(cert.id, doc.id, 'nombre', e.target.value)}
                                              />
                                            </td>
                                            <td>
                                              <span
                                                className="recepcion-fecha-texto"
                                                title={alertaEsperada ? alertaEsperada.label : ''}
                                                style={alertaEsperada ? { background: alertaEsperada.bg, color: alertaEsperada.color, border: `1px solid ${alertaEsperada.border}` } : {}}
                                              >
                                                {formatearFecha(doc.fechaEsperada)}
                                              </span>
                                            </td>
                                            <td className="recepcion-td-archivos">
                                              <div className="recepcion-archivos-container">
                                                {doc.archivos.length > 0 && (
                                                  <div className="recepcion-archivos-lista">
                                                    {doc.archivos.map((arch, archIdx) => (
                                                      <div key={archIdx} className="recepcion-archivo-item">
                                                        <span className="recepcion-archivo-titulo" title={arch.nombre}>
                                                          {arch.nombre}
                                                        </span>
                                                        <div className="recepcion-archivo-acciones">
                                                          {arch.archivoBase64 && (
                                                            <a
                                                              href={`data:${arch.mimeType || 'application/octet-stream'};base64,${arch.archivoBase64}`}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className="recepcion-archivo-ver"
                                                              title="Ver archivo"
                                                            >
                                                              👁
                                                            </a>
                                                          )}
                                                          <button
                                                            className="recepcion-archivo-eliminar"
                                                            onClick={() => eliminarArchivo(cert.id, doc.id, archIdx)}
                                                            title="Eliminar archivo"
                                                          >
                                                            ✕
                                                          </button>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                                <input
                                                  type="file"
                                                  multiple
                                                  ref={el => fileInputRefs.current[fileInputKey] = el}
                                                  style={{ display: 'none' }}
                                                  onChange={(e) => {
                                                    agregarArchivos(cert.id, doc.id, e.target.files);
                                                    e.target.value = '';
                                                  }}
                                                />
                                                <button
                                                  className="recepcion-btn-subir-archivo"
                                                  onClick={() => fileInputRefs.current[fileInputKey]?.click()}
                                                  title="Subir archivos"
                                                >
                                                  📎 Subir
                                                </button>
                                              </div>
                                            </td>
                                            <td>
                                              <textarea
                                                className="recepcion-input recepcion-observaciones-textarea"
                                                placeholder="Observaciones..."
                                                defaultValue={doc.observaciones}
                                                rows={2}
                                                onBlur={(e) => {
                                                  if (e.target.value !== doc.observaciones) {
                                                    onActualizarDocumento(cert.id, doc.id, { observaciones: e.target.value });
                                                  }
                                                }}
                                                onChange={(e) => actualizarCampoDocConDebounce(cert.id, doc.id, 'observaciones', e.target.value)}
                                              />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                              <button
                                                className="recepcion-btn-eliminar"
                                                onClick={() => eliminarDocumento(cert.id, doc.id)}
                                                title="Eliminar documento"
                                              >
                                                ✕
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                  {/* Botón/formulario para agregar documento */}
                                  <div className="recepcion-add-doc-row">
                                    {agregarDocPartida === cert.id ? (
                                      <form
                                        className="recepcion-add-doc-form"
                                        onSubmit={(e) => { e.preventDefault(); agregarDocumentoAPartida(cert.id); }}
                                      >
                                        <input
                                          type="text"
                                          className="recepcion-input"
                                          placeholder="Nombre del documento..."
                                          value={nuevoDocNombre}
                                          onChange={(e) => setNuevoDocNombre(e.target.value)}
                                          autoFocus
                                        />
                                        <button type="submit" className="recepcion-btn-add-doc-ok" disabled={!nuevoDocNombre.trim()}>
                                          ✓
                                        </button>
                                        <button
                                          type="button"
                                          className="recepcion-btn-add-doc-cancel"
                                          onClick={() => { setAgregarDocPartida(null); setNuevoDocNombre(''); }}
                                        >
                                          ✕
                                        </button>
                                      </form>
                                    ) : (
                                      <button
                                        className="recepcion-btn-add-documento"
                                        onClick={() => setAgregarDocPartida(cert.id)}
                                      >
                                        + Agregar Documento
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                );
              })}

            </tbody>
          </table>
        </div>

      </section>
    </div>
  );
};

export default MatrizRecepcion;
